import axios from 'axios';
import { API_URL } from '../api_url';
import store from '../store';
import MockService from './mock.service';

class SmtpService {
    getSmtpConfig() {
        if (MockService.shouldUseMocks()) {
            return MockService.mockGetSmtpConfig();
        }
        
        return axios
            .get(`https://${API_URL}/v1/client/smtp-config`, { 
                headers: { 'Authorization': store.state.auth.sessionId } 
            })
            .then(response => {
                return response.data;
            });
    }
    
    updateSmtpConfig(smtpConfig) {
        if (MockService.shouldUseMocks()) {
            return MockService.mockUpdateSmtpConfig(smtpConfig);
        }
        
        return axios
            .put(`https://${API_URL}/v1/client/smtp-config`, smtpConfig, { 
                headers: { 'Authorization': store.state.auth.sessionId } 
            })
            .then(response => {
                return response.data;
            });
    }
    
    testSmtpConnection(smtpConfig) {
        if (MockService.shouldUseMocks()) {
            return MockService.mockTestSmtpConnection(smtpConfig);
        }
        
        return axios
            .post(`https://${API_URL}/v1/client/smtp-config/test`, smtpConfig, { 
                headers: { 'Authorization': store.state.auth.sessionId } 
            })
            .then(response => {
                return response.data;
            });
    }
}

export default new SmtpService();